<template>
    <div>
  
      <!-- Message box -->
      <div
          v-if="message"
          :class="messageType"
          class="mt-24 fixed top-5 left-1/2 transform -translate-x-1/2 p-4 rounded-lg text-center shadow-lg text-black dark:bg-dark-box-bg dark:text-dark-text dark:border dark:border-dark-border transition-all duration-500"
          style="width: 90%; max-width: 1200px; z-index: 3000;"
      >
  
      {{ message }}
        <div
            class="z-5000 absolute bottom-0 left-0 h-1"
            :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }"
        ></div>
      </div>
  
      <!-- Przycisk dzwonka z liczbą powiadomień -->
      <div v-if="isAuthenticated && authStore.user.role != 'ROLE_DRIVER'" class="fixed top-8 right-28 z-2000">
        <button
            @click="openModal"
            ref="notificationButton"
            class="bg-button-bg text-button-text p-4 rounded-full shadow-lg focus:outline-none hover:bg-button-hover relative transition-all duration-200 ease-in-out transform hover:scale-110 active:scale-95 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
        >
          <ChatBubbleBottomCenterIcon
              class="h-6 w-6 transition-transform duration-200 ease-in-out transform"
              :class="{ 'animate-bell': isBellRinging }"
              @mouseover="isBellRinging = true"
              @mouseleave="isBellRinging = false"
          />
        </button>
      </div>
  
      <!-- Widget z powiadomieniami -->
      <transition name="slide-fade">
        <ChatModal 
          v-if="isModalOpen && user?.uid"
          :isModalOpen="isModalOpen"
          :drivers="drivers"
          :senderId="user.uid"
          v-model:activeChatDriverId="activeChatDriverId"
          @close="closeModal"
          @start-chat="startChat"
        />
      </transition>
    </div>
  </template>
  
  
  <script>
  import { useAuthStore } from '@/stores/authStore';
  import { ChatBubbleBottomCenterIcon} from '@heroicons/vue/24/solid';
  import { computed } from 'vue';
  import driversService from '@/services/driversService';
  import ChatModal from './chat/ChatModal.vue';
  import { ref, watch } from 'vue';
  
  export default {
    components: {
      ChatBubbleBottomCenterIcon,
      ChatModal
    },
    setup() {
      const authStore = useAuthStore();
      const user = computed(() => authStore.user);
      const isAuthenticated = computed(() => authStore.isAuthenticated);

      const activeChatDriverId = ref(null);

      // Watcher, który reaguje na zmianę użytkownika
      watch(user, (newUser) => {
        if (newUser && newUser.uid) {
          // Teraz możemy korzystać z newUser.uid
          // console.log('Użytkownik jest załogowany:', newUser.uid);
        } else {
          // console.log('Brak użytkownika');
        }
      }, { immediate: true });

      return { user, isAuthenticated, activeChatDriverId, authStore };
    },
    data() {
      return {
        isBellRinging: false,
        warnings: [],
        showWarnings: false,  
        // Message box state
        message: '',
        messageType: '',
        progress: 0,
        isModalOpen: false,
        drivers: [],
      };
    },
    computed: {
      unreadNotifications() {
        return Array.isArray(this.notifications)
        ? this.notifications.filter(notification => !notification.read)
        : [];
      },
      activeDriver() {
        return this.drivers.find(driver => driver.id === this.activeChatDriverId) || {};
      },
    },
    mounted() {
      this.fetchDrivers();
    },
    methods: {
      openModal() {
        this.isModalOpen = true;
        this.fetchDrivers();
      },
      closeModal() {
        this.isModalOpen = false;
      },
      startChat(driver) {
        this.activeChatDriverId = driver.id;
      },
      async fetchDrivers() {
        const authStore = useAuthStore();
        if (authStore.isAuthenticated && this.user.role != 'ROLE_DRIVER')
        {
          try {
            const response = await driversService.getAllDrivers();
            this.drivers = response.data;

            // console.log(this.drivers)

          } catch (error) {
            console.error('Błąd podczas pobierania powiadomień:', error);
          }
        }
      },
      showMessage(msg, type) {
        this.message = msg;
        this.messageType = type === "success" ? "bg-green-500 text-white" : "bg-red-500 text-white";
        this.progress = 0;
  
        const interval = 30; // Odświeżanie progresu
        const duration = 3000; // Czas wyświetlania (3 sekundy)
        const step = 100 / (duration / interval);
  
        const progressInterval = setInterval(() => {
          this.progress += step;
          if (this.progress >= 100) {
            clearInterval(progressInterval);
            this.progress = 0;
            this.message = '';
            this.messageType = '';
            this.clearMessage();
          }
        }, interval);
      },
      clearMessage() {
        this.message = '';
        this.messageType = '';
        this.progress = 0;
      },
      getProgressColor() {
        return this.messageType === "bg-green-500 text-white" ? "#16a34a" : "#b91c1c";
      },
      formatDate(dateString) {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
    },
  };
  </script>
  
  <style scoped>
  /* Animacja dzwonka */
  @keyframes bell {
    0% { transform: translateY(0); }
    25% { transform: translateY(-2px); }
    50% { transform: translateY(0); }
    75% { transform: translateY(6px); }
    100% { transform: translateY(0); }
  }
  .animate-bell {
    animation: bell 0.3s ease forwards;
  }
  
  /* Styl animacji wysuwania boxa */
  .slide-fade-enter-active, .slide-fade-leave-active {
    transition: transform 0.3s ease, opacity 0.3s ease;
  }
  .slide-fade-enter-from {
    transform: translateY(-20px) scale(0.95);
    opacity: 0;
  }
  .slide-fade-enter-to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  .slide-fade-leave-from {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  .slide-fade-leave-to {
    transform: translateY(-20px) scale(0.95);
    opacity: 0;
  }
  
  /* Styl paska przewijania dla dark i light mode */
  .overflow-y-auto::-webkit-scrollbar {
    width: 8px;
  }
  .overflow-y-auto::-webkit-scrollbar-thumb {
    background-color: #d1d5db; /* Jasnoszary kolor dla trybu light */
    border-radius: 8px;
    border: 2px solid #9ca3af;
  }
  .overflow-y-auto::-webkit-scrollbar-track {
    background-color: #f3f4f6;
    border-radius: 8px;
  }
  
  /* Pasek przewijania w trybie ciemnym */
  .dark .overflow-y-auto::-webkit-scrollbar-thumb {
    background-color: #2c7a7a; /* Teal-700 */
    border-radius: 8px;
    border: 2px solid #1a5d5d; /* Ciemniejszy teal dla suwaka */
  }
  .dark .overflow-y-auto::-webkit-scrollbar-track {
    background-color: #333333;
    border-radius: 8px;
  }
  </style>
  